/* eslint-disable */
// @ts-nocheck

import moment from 'moment'
/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useState } from 'react'

import useServerOnlineClients from '../../../../api/useServerOnlineClients'
import AsyncComboBox from '../../../../components/forms/AsyncCombobox'
import ComboBox from '../../../../components/forms/Combobox'
import CurrencyAmountInput from '../../../../components/forms/CurrencyAmountInput'
import DateInput from '../../../../components/forms/DateInput'
import Input from '../../../../components/forms/Input'
import Select from '../../../../components/forms/Select'
import TextArea from '../../../../components/forms/TextArea'
import Button from '../../../../components/misc/Button'
import Modal from '../../../../components/misc/GenericModal'
import GenericTable, {
  DataTableInterface,
} from '../../../../components/misc/GenericTable'
import { SelectInterface } from '../../../../interfaces/InterfacesLocal'
import { OnlineClientInterface } from '../../../../interfaces/ServerInterfaces'
import { useAppSelector } from '../../../../store/hooks'
import { RegisterContext } from '../AllRegistersList'
import { EditContextBilling } from '../registerDetailsTabs/RegisterDetailsTab'

export const ShippingStep = ({ onSubmitForm }: { onSubmitForm: Function }) => {
  const {
    control,
    watch,
    setCurrentStep,
    currentStep,
    setValue,
    getValues,
    isSubmit,
    setOpenPayModal,
    isFetching,
    shippingRegions,
    handleSubmit,
  } = useContext(RegisterContext)
  const { availableCurrencies, configurationsKey } = useAppSelector(
    (state) => state.init.business!
  )
  const { deliverymans } = useAppSelector((state) => state.nomenclator!)

  const { getAllClients, getClient, allClients } = useServerOnlineClients()

  const { defaultValues, editMode } = useContext(EditContextBilling)

  const [showClientAddressModal, setShowClientAddressModal] = useState(false)

  const [loadingHelper, setLoadingHelper] = useState(false)
  const isPickUp = !watch('shippingType')
  const municipalityId = watch('shipping.municipalityId')
  const [selectDelivers, setSelectDelivers] = useState<SelectInterface[]>([])
  const currencies = availableCurrencies.map((item) => item.code) ?? []

  const [shippingRegionSelect, setShippingRegionSelect] = useState<
    SelectInterface[]
  >([])
  const deliveryType = configurationsKey.find(
    (conf) => conf.key === 'delivery_type'
  )!.value
  const deliveryFixedPrice = configurationsKey.find(
    (conf) => conf.key === 'amount_delivery_fixed'
  )!.value
  const deliveryCurrency = configurationsKey.find(
    (conf) => conf.key === 'general_cost_currency'
  )!.value
  const defaultShippingPrice = {
    amount: defaultValues?.shippingPrice?.amount!,
    codeCurrency: defaultValues?.shippingPrice?.codeCurrency!,
  }

  const [client, setClient] = useState<OnlineClientInterface>()

  useEffect(() => {
    getAllClients({ all_data: true })
  }, [])

  useEffect(() => {
    setValue!(
      'deliveryAt',
      editMode ? defaultValues?.deliveryAt : moment().format(`YYYY-MM-DD HH:mm`)
    )
    if (editMode) {
      setValue!('shipping.countryId', defaultValues?.shipping?.country?.id)
      setValue!('shipping.provinceId', defaultValues?.shipping?.province?.id)
      setValue!(
        'shipping.municipalityId',
        defaultValues?.shipping?.municipality?.id
      )
      setValue!('shipping.shippingRegionId', defaultValues?.shippingRegion?.id)
    }
  }, [])

  useEffect(() => {
    if (deliveryType === 'BYREGION') {
      if (shippingRegions) {
        const region: SelectInterface[] = shippingRegions
          .filter((item) => item.municipality.id === municipalityId)
          .map((item) => {
            return {
              id: item.id,
              name: `${item.name} - ${item.price.amount}${item.price.codeCurrency}`,
            }
          })
        setShippingRegionSelect(region)
      }
    }
  }, [shippingRegions, municipalityId])

  //Cargar Mensajeros
  useEffect(() => {
    const newSelect: SelectInterface[] =
      deliverymans
        ?.filter((item) => item.roles?.some((rol) => rol.name === 'Repartidor'))
        .map((item) => {
          return {
            id: item.id,
            name: item.displayName,
          }
        }) ?? []
    setSelectDelivers(newSelect)
  }, [deliverymans])

  const clientId = watch!('clientId')

  // const client = allClients.find((item) => item.id === clientId)
  const loadClientData = () => {
    setClient(undefined)
    getClient(clientId, (clientData: OnlineClientInterface) => {
      console.log(clientData)
      setClient(clientData)
    })

    setShowClientAddressModal(true)
  }

  return (
    <div className="grid gap-y-6 px-8">
      <form className="min-h-[25rem]">
        <div className={'flex flex-col'}>
          <div className={'flex items-center justify-between'}>
            <h1 className={'mb-2 text-lg font-bold text-gray-700'}>
              Datos del Receptor:
            </h1>
            <div>
              <Button
                action={() => {
                  loadClientData()
                }}
                color="white"
                name="Direcciones del cliente"
                textColor="slate-700"
                type="button"
              />
            </div>
          </div>
          <div className="flex w-full gap-x-4 pb-4">
            <div className="flex w-1/2 flex-col gap-2">
              <div>
                <Input
                  control={control}
                  defaultValue={editMode && defaultValues?.shipping?.firstName}
                  disabled={isPickUp}
                  label="Nombre (*)"
                  name={'shipping.firstName'}
                  rules={{
                    required: {
                      value: true,
                      message: 'Este campo es requerido',
                    },
                  }}
                  type="textOnly"
                />
              </div>

              <div>
                <Input
                  control={control}
                  defaultValue={
                    editMode ? defaultValues?.shipping?.lastName : null
                  }
                  disabled={isPickUp}
                  label="Apellidos (*)"
                  name="shipping.lastName"
                  rules={{
                    required: {
                      value: true,
                      message: 'Este campo es requerido',
                    },
                  }}
                  type="textOnly"
                />
              </div>

              <div>
                <Input
                  control={control}
                  defaultValue={editMode && defaultValues?.shipping?.phone}
                  disabled={isPickUp}
                  label="Teléfono"
                  maxLength={10}
                  name="shipping.phone"
                  textAsNumber
                  type="number"
                />
              </div>

              <div>
                <Input
                  control={control}
                  defaultValue={editMode && defaultValues?.shipping?.email}
                  disabled={isPickUp}
                  label="Correo electrónico"
                  name="shipping.email"
                />
              </div>

              <div>
                <Input
                  control={control}
                  defaultValue={editMode && defaultValues?.shipping?.postalCode}
                  disabled={isPickUp}
                  label="Código postal"
                  maxLength={10}
                  name="shipping.postalCode"
                  textAsNumber
                  type="number"
                />
              </div>

              {/*<div className="pt-2">
                                    <Input
                                        label="Localidad"
                                        name="shipping.city"
                                        control={control}
                                        disabled={isPickUp}
                                        // rules={{
                                        //   required: {
                                        //     value: !isPickUp,
                                        //     message: "Este campo es requerido",
                                        //   },
                                        // }}
                                        defaultValue={editMode && defaultValues?.shipping?.city}
                                    />
                                </div>*/}
            </div>

            <div className="flex w-1/2 flex-col gap-2">
              <div>
                <Input
                  control={control}
                  defaultValue={editMode && defaultValues?.shipping?.street_1}
                  label="Calle principal"
                  disabled={isPickUp}
                  // rules={{
                  //   required: {
                  //     value: !isPickUp,
                  //     message: "Este campo es requerido",
                  //   },
                  // }}
                  name="shipping.street_1"
                />
              </div>

              <div>
                <Input
                  control={control}
                  defaultValue={editMode && defaultValues?.shipping?.street_2}
                  disabled={isPickUp}
                  label="Calle secundaria"
                  name="shipping.street_2"
                />
              </div>

              <div>
                <AsyncComboBox
                  defaultItem={{
                    id: 54,
                    name: 'Cuba',
                  }}
                  defaultValue={54}
                  disabled={isPickUp}
                  label="País  (*)"
                  name="shipping.countryId"
                  normalizeData={{ id: 'id', name: 'name' }}
                  rules={{
                    required: {
                      value: !isPickUp && deliveryType === 'BYREGION',
                      message: 'Este campo es requerido',
                    },
                  }}
                  control={control}
                  // id : cuba
                  dataQuery={{
                    url: '/public/countries',
                    defaultParams: { id: 54, all_data: true },
                  }}
                />
              </div>

              <div>
                <AsyncComboBox
                  control={control}
                  dataQuery={{ url: '/public/provinces' }}
                  defaultValue={
                    editMode ? defaultValues?.shipping?.province?.id : undefined
                  }
                  dependendValue={{
                    countryId:
                      watch!('shipping.countryId') ??
                      getValues!('shipping.countryId'),
                  }}
                  disabled={isPickUp || !watch!('shipping.countryId')}
                  label="Provincia"
                  name="shipping.provinceId"
                  normalizeData={{ id: 'id', name: 'name' }}
                  rules={{
                    required: {
                      value: !isPickUp && deliveryType === 'BYREGION',
                      message: 'Este campo es requerido',
                    },
                  }}
                />
              </div>

              <div>
                <AsyncComboBox
                  control={control}
                  dataQuery={{ url: '/public/municipalities' }}
                  defaultValue={
                    editMode
                      ? defaultValues?.shipping?.municipality?.id
                      : undefined
                  }
                  dependendValue={{
                    provinceId:
                      watch!('shipping.provinceId') ??
                      getValues!('shipping.provinceId'),
                  }}
                  disabled={isPickUp || !watch!('shipping.provinceId')}
                  label="Municipio"
                  name="shipping.municipalityId"
                  normalizeData={{ id: 'id', name: 'name' }}
                  rules={{
                    required: {
                      value: deliveryType === 'BYREGION',
                      message: 'Este campo es requerido',
                    },
                  }}
                />
              </div>
            </div>
          </div>
          <div>
            <TextArea
              control={control}
              defaultValue={editMode && defaultValues?.shipping?.description}
              disabled={isPickUp}
              label="Añadir notas"
              name="shipping.description"
            />
          </div>
          <div className={'flex flex-col'}>
            <h1 className={'mb-2 text-lg font-bold text-gray-700'}>
              Datos del Envío:
            </h1>
            <div className={'flex space-x-4'}>
              <ComboBox
                className={'w-full'}
                control={control}
                data={selectDelivers}
                defaultValue={editMode ? defaultValues?.shippingBy?.id : null}
                label={'Mensajero'}
                name={'shippingById'}
                optionsClassName={'w-full'}
                placeholder={'Seleccione un Mensajero'}
              />
              <DateInput
                control={control}
                flexCol={true}
                includeTime={true}
                label={'Fecha de Envío'}
                name={'deliveryAt'}
              />
            </div>

            <div className={'mt-2 flex space-x-2'}>
              {deliveryType === 'BYREGION' && (
                <Select
                  asyncDefaultValue={true}
                  className={'w-full'}
                  control={control}
                  data={shippingRegionSelect}
                  defaultValue={
                    editMode ? defaultValues?.shipping?.shippingRegionId : null
                  }
                  label={'Región de envío  (*)'}
                  name={'shipping.shippingRegionId'}
                  rules={{
                    required: {
                      value: true,
                      message: 'Este campo es requerido',
                    },
                  }}
                />
              )}
              {deliveryType !== 'BYREGION' && (
                <CurrencyAmountInput
                  byDefault={
                    editMode
                      ? defaultShippingPrice
                      : deliveryType === 'FIXED'
                        ? {
                            amount: Number(deliveryFixedPrice),
                            codeCurrency: deliveryCurrency,
                          }
                        : {
                            amount: 0,
                            codeCurrency: deliveryCurrency,
                          }
                  }
                  control={control}
                  currencies={currencies}
                  disabled={deliveryType === 'FIXED'}
                  label={'Precio de envío'}
                  name={'shippingPrice'}
                  placeholder={'Precio'}
                  rules={{
                    required: {
                      value: true,
                      message: 'Este campo es requerido',
                    },
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </form>
      {!editMode && (
        <div className="flex h-fit w-full justify-between gap-3 pt-2">
          <Button
            action={() => {
              setCurrentStep!(currentStep! - 1)
            }}
            color="white"
            disabled={currentStep === 0 ? true : false}
            full
            name="Atrás"
            outline
            textColor="blue-800"
            type="button"
          />
          <Button
            color={
              watch!('registerType') === 'PRE-BILLING' ? 'slate-700' : 'white'
            }
            loading={isSubmit && !loadingHelper}
            name="Registrar"
            textColor={
              watch!('registerType') === 'PRE-BILLING' ? undefined : 'blue-800'
            }
            disabled={isSubmit}
            //@ts-ignore FIXME:
            action={onSubmitForm && handleSubmit!(onSubmitForm)}
            outline={watch!('registerType') !== 'PRE-BILLING'}
            //type="submit"
            full
          />
          {watch!('registerType') !== 'PRE-BILLING' && (
            <Button
              action={() => {
                //Action para abrir el modal de pago directa,mente
                setOpenPayModal && setOpenPayModal(true)
                setLoadingHelper(true)
                onSubmitForm && onSubmitForm(true)
              }}
              color="slate-700"
              disabled={isSubmit}
              full
              loading={isSubmit && loadingHelper}
              name="Registrar y facturar"
              type="submit"
            />
          )}
        </div>
      )}

      {editMode && (
        <div className="row-span-2 flex w-full items-end justify-end">
          <div className="grid">
            <Button
              color="slate-700"
              disabled={isFetching}
              full
              loading={isFetching}
              name={editMode ? 'Actualizar' : `Registrar`}
              type="submit"
            />
          </div>
        </div>
      )}
      {showClientAddressModal && client && (
        <Modal
          close={setShowClientAddressModal}
          size={'m'}
          state={showClientAddressModal}
        >
          <AddressSelectModal
            client={client}
            close={() => setShowClientAddressModal(false)}
          />
        </Modal>
      )}
    </div>
  )
}
interface AddressModalProps {
  client: OnlineClientInterface
  close: () => void
}
function AddressSelectModal({ client, close }: AddressModalProps) {
  const { setValue } = useContext(RegisterContext)
  const serverOnlineClients = useServerOnlineClients()
  const { getAllAddress, allAddress, isLoading } = serverOnlineClients
  const tableTitles = [
    'Calle principal',
    'Calle secundaria',
    'Localidad',
    'País',
    'Provincia',
    'Municipio',
    'Código postal',
    'Descripción',
  ]
  useEffect(() => {
    if (client) getAllAddress!(client.id)
  }, [])

  const tableData: DataTableInterface[] = allAddress.map((item) => ({
    rowId: item.id,
    payload: {
      'Calle principal': item.street_1 ?? '-',
      'Calle secundaria': item?.street_2 ?? '-',
      Localidad: item?.city ?? '-',
      País: item?.country?.name ?? '-',
      Provincia: item?.province?.name ?? '-',
      Municipio: item?.municipality?.name ?? '-',
      'Código postal': item?.postalCode ?? '-',
      Descripción: item?.description ?? '-',
    },
  }))

  const rowAction = (id: number) => {
    const current = allAddress.find((item) => item.id === id)
    if (current) {
      if (client) {
        setValue('shipping.firstName', client?.firstName ?? '')
        setValue('shipping.lastName', client?.lastName ?? '')
        setValue('shipping.phone', client.phones[0]?.number ?? '')
        setValue('shipping.email', client?.email ?? '')
        setValue('shipping.postalCode', current?.postalCode ?? '')
        setValue('shipping.street_1', current?.street_1 ?? '')
        setValue('shipping.street_2', current?.street_2)
        setValue('shipping.countryId', current?.country?.id)
        setValue('shipping.provinceId', current?.province?.id)
        setValue('shipping.municipalityId', current?.municipality?.id)
        setValue('shipping.description', current?.description)
      }
      close()
    }
  }
  return (
    <div>
      <h2 className={'text-xl font-bold text-gray-600'}>
        Seleccione la dirección que desea añadir
      </h2>
      <div className={'mt-5'}>
        <GenericTable
          loading={isLoading}
          rowAction={rowAction}
          tableData={tableData}
          tableTitles={tableTitles}
        />
      </div>
    </div>
  )
}
